import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/Button'
import Logo from '../../img/icon-mdm-bg-white.svg'
import styles from '../../css/modals/ModalActivateLicense.module.css'
import { ProgressSpinner } from 'primereact/progressspinner'
import $ from 'jquery'
import { postData } from '../../actions/servicesHttp'
import { useNavigate } from 'react-router-dom'

export default function ModalActivateLicense ({ data, onHide, title, show, btnError, btnSuccess, reload }) {
  const { t } = useTranslation('dashboardDevice')
  const [loading, setLoading] = useState(false)
  const [code, setCode] = useState('')
  const [licenseActivationMdmCentral] = useState('license_activation')
  const navigate = useNavigate()

  const validateSO = (so) => {
    const os = so?.toLowerCase()

    return (
      (os?.includes('chrome os') && 'C') ||
        (os?.includes('android') && 'A') ||
        (os?.includes('windows') && 'W') ||
        (os?.includes('ubuntu') && 'U') ||
        (os?.includes('debian') && 'D') ||
        (os?.includes('ios') && 'I') ||
        (os?.includes('mac') && 'M') ||
        ''
    )
  }

  function closeModal () {
    onHide()
    setCode('')
    const errorCodeActivation = document.getElementById('errorCode')
    const messageErrorCodeActivation = document.getElementById('messageError')
    messageErrorCodeActivation.innerText = ''
    errorCodeActivation.style.display = 'none'
    reload()
  }

  const handleInputChange = (e) => {
    let symbol = e.target.value.toUpperCase()
    symbol = symbol.replace(/[^0-9A-F]/g, '')
    symbol = symbol.slice(0, 20)

    const formatted = symbol.match(/.{1,5}/g)?.join('-') || ''

    setCode(formatted)
  }

  const clearErrorMessages = () => {
    $('#errorCodeActivation').text('')
    $('#inputCodeActivation').removeClass(`${styles.error}`)
  }

  const validationsInputs = () => {
    let response = true

    const messageRequire = t('modalActivateLicense.label1')
    const codeActivation = document.getElementById('inputCodeActivation')

    if (codeActivation?.value === '') {
      $('#inputCodeActivation').addClass(`${styles.error}`)
      $('#errorCodeActivation').text(messageRequire)
      response = false
    }
    if (response) clearErrorMessages()
    return response
  }

  const ActivationCode = async (code, data, url) => {
    $('#btnSucessModalActivateLicense').prop('disabled', true)
    const errorCodeActivation = document.getElementById('errorCode')
    const messageErrorCodeActivation = document.getElementById('messageError')
    setLoading(true)
    errorCodeActivation.style.display = 'none'
    const validation = validationsInputs()
    if (validation) {
      const body = {
        identity: data?.identity,
        so: validateSO(data?.so),
        activationCode: code
      }
      const response = await postData(url, body, navigate)
      errorCodeActivation.style.display = 'block'
      if (response.status === 200) {
        messageErrorCodeActivation.innerText = t('modalActivateLicense.label2')
      } else {
        messageErrorCodeActivation.innerText = response?.data?.error
        console.log({ error: true, response })
      }
    }
    setLoading(false)
    $('#btnSucessModalActivateLicense').prop('disabled', false)
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'activateLicense'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.bodyModal}>
                        <img alt='logo del MDM' src={Logo} className={styles.logo} />
                        <label htmlFor="inputCodeActivation" className={styles.message}>{t('modalActivateLicense.message1')}</label>
                        <input
                            name='codeActivation'
                            id='inputCodeActivation'
                            type='text'
                            value={code}
                            onChange={(e) => handleInputChange(e)}
                            placeholder={t('modalActivateLicense.placeholder')}
                            className={styles.inputMask}
                            maxLength={23}
                        />
                        <p className={styles.errorMessage} id='errorCodeActivation'></p>
                    </div>
                    <div className={styles.loadingContainer}>
                        {loading && <ProgressSpinner style={{ width: '2.5rem', height: '2.5rem' }} strokeWidth="5" />}
                    </div>
                    <p id="errorCode" className={styles.errorCode}><i className="fas fa-exclamation-circle"></i><span id="messageError"></span></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => ActivationCode(code, data, licenseActivationMdmCentral)} variant="primary" id="btnSucessModalActivateLicense" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalActivateLicense.propTypes = {
  onHide: PropTypes.func,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  data: PropTypes.object,
  reload: PropTypes.func
}
